var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceList',{ref:"resourceList",attrs:{"params":_vm.params,"query":_vm.query,"resource":_vm.resource,"renderAs":_vm.renderAs,"useRouter":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }